import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, filter, map, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromShared from '../../shared';
import { ResponseStatus } from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ReportService } from '../report.service';
import * as FeatureActions from './report.actions';
import * as fromReports from './report.actions';

@Injectable()
export class ReportEffects {
    constructor(
        private actions$: Actions,
        private service: ReportService,
        private store: Store,
        private log: LoggingService
    ) {}

    GetReports$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FeatureActions.getReports),
            switchMap(
                action =>
                    this.service.get(action.EmployeeListID).pipe(
                        map(data =>
                            FeatureActions.loadReports({ reports: data })
                        ),
                        // retryBackoff(1000),
                        catchError(fromShared.Errors.handleServiceError)
                    )
                // catchError(error => of(FeatureActions.actionFailure({ error }))))
            )
        );
    });

    setReportParams$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(FeatureActions.setReportParams),
                map(a => this.service.postParams(a.params))
            );
        },
        { dispatch: false }
    );
    reportFavorite$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FeatureActions.reportFavorite),
            concatMap(action => {
                return this.service.favoriteReport(action.report).pipe(
                    map(() => {
                        return fromReports.getReports({ EmployeeListID: action.report.EmployeeListID });
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                );
            })
        );
    });
    runReport$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FeatureActions.runReport),
            concatMap(action => {
                return this.service.postParams(action.report.params).pipe(
                    map(() => {
                        // .then(() => {
                        const popup = window.open(
                            `${environment.reportsLocation}?RptID=${
                                action.report.report.RptID
                            }&${Object.keys(action.report.queryparams).reduce(
                                (a, c) =>
                                    `${a}&${c}=${action.report.queryparams[c]}`,
                                ''
                            )}`,
                            `_${action.report.report.RptID}`
                        );
                        return fromReports.setPopupBlocker({
                            value:
                                !popup ||
                                popup.closed ||
                                typeof popup.closed === 'undefined'
                        });
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                );
            })
        );
    });

    popupBlocker$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FeatureActions.setPopupBlocker),
            filter(a => !!a.value),
            switchMap(() =>
                of(
                    new fromShared.Errors.SetErrors([
                        {
                            Message:
                                'A pop-up block is turned on and preventing multiple reports from opening at once using additional browser tabs. <br/>Perform a web search on " allowing pop-ups from a specific site" for your internet browser version and set https://reports.efaactcentral.com as a safe site.',
                            StatusCode: ResponseStatus.Failed
                        }
                    ])
                )
            )
        );
    });
}
